// Where each kind of record lives, in one place.
//
// Search, the command palette, the dashboard and the record pages each built
// their own paths, and half of them pointed somewhere that ignored them:
// `/clients` had no route, `?project_id` and `?client_id` were read by nothing,
// and a project opened from search lost itself on refresh. Every link to a
// record goes through here, and every page named here reads its parameter and
// keeps it in the address bar while the record is open, so Back, refresh and a
// pasted link all land on the record rather than on a list.

const q = (params) => {
  const s = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== '') s.set(k, v) })
  const str = s.toString()
  return str ? `?${str}` : ''
}

export const clientPath = (id) => (id ? `/admin${q({ client: id })}` : '/admin')

export const projectPath = (id, tab) => (id ? `/projects${q({ project: id, tab })}` : '/projects')

export const invoicePath = (id) => (id ? `/invoices${q({ invoice: id })}` : '/invoices')

/** Rich proposals are edited in the studio; older ones open in the classic form. */
export const proposalPath = (proposal) => {
  if (!proposal?.id) return '/proposals'
  return proposal.proposal_type === 'rich'
    ? `/proposals/${proposal.id}/studio`
    : `/proposals${q({ proposal: proposal.id })}`
}

/** A new proposal already addressed to someone. */
export const newProposalPath = ({ clientId, leadId } = {}) => `/proposals${q({ new: 1, client: clientId, lead: leadId })}`

export const timePath = ({ clientId, projectId } = {}) => `/time${q({ client: clientId, project: projectId })}`

export const messagesPath = (clientId) => `/messages${q({ client: clientId })}`
